import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //
const publicRoutes = [
    '/terms',
    '/terms/',
    '/locations',
    '/locations/',
    '/responsiblegaming',
    '/responsiblegaming/',
    '/privacypolicy',
    '/privacypolicy/',
    '/aboutus',
    '/aboutus/',
    '/betrules',
    '/betrules/',
    '/contactus',
    '/contactus/',
    '/faqs',
    '/faqs/',
    '/details',
    '/details/',
    '/gettingstarted',
    '/gettingstarted/',
    '/depositswithdrawals',
    '/depositswithdrawals/',
    '/sportsbetsenquiries',
    '/sportsbetsenquiries/',
    '/accountassistance',
    '/accountassistance/',
    '/trustsafety',
    '/trustsafety/',
    '/payment/return',
    '/payment/return/:id',
    '/payment/cancel',
    '/payment/cancel/:id',
    '/maintenance',
    '/maintenance/',
    '/accessdenied',
    '/accessdenied/',
    '/devicelimit',
    '/devicelimit/',
    '/raceresults/karambola',
    '/raceresults/karambola/',
    '/raceresults/ihr',
    '/raceresults/ihr/',
    '/results/luckysign/',
    '/results/luckysign'
];
/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // console.log(user, 'user in auth guard');
        // debugger;
        const currentPath = location.pathname;
        const isPublic = publicRoutes.includes(currentPath) || publicRoutes.some((route) => currentPath.startsWith(route));

        if (!isLoggedIn && !isPublic) {
            navigate('/', { replace: true });
        }
        const allowedPayoutPath = isLoggedIn && ['SCAN-OPERATOR', 'PAYOUT-OPERATOR'].includes(user?.partnerUserType);

        const showRedirectPayout = isLoggedIn && allowedPayoutPath && (location.pathname === '/' || location.pathname === '');

        if (showRedirectPayout) {
            navigate('/payout', { replace: true });
        }
        // if /payout then check isSaleOperator permission no permission redirect to accessdenied
        const allowedPayoutWithLandHomePagePath =
            isLoggedIn && (user?.isSaleOperator === 'Y' || ['SCAN-OPERATOR', 'PAYOUT-OPERATOR'].includes(user?.partnerUserType));
        const showScanPayout =
            isLoggedIn &&
            !allowedPayoutWithLandHomePagePath &&
            (location.pathname === '/payout' || location.pathname.startsWith('/payout/'));

        if (0) {
            navigate('/accessdenied', { replace: true });
        }
    }, [isLoggedIn, location.pathname, navigate, user, user?.partnerUserType]);

    return children;
};

export default AuthGuard;
